import React from 'react';
import PropTypes from 'prop-types';
import styles from './customInput.module.css';

const TextField = ({
  id,
  value,
  label,
  type,
  maxLength = '',
  onChange,
  name,
  error,
  onBlur,
  required = false,
  className = '',
  disable = false,
  classNameLabel = '',
  classNameError = '',
  autofocus = false,
  onKeyPress = '',
  ref = null,
  readOnly = false,
  max = '',
}) => {
  return (
    <>
      {id === 'tac' ? (
        <div className={`form-group ${className}`}>
          <input
            id={id}
            type={type || 'text'}
            value={value}
            onChange={onChange}
            name={name}
            className={
              error
                ? `form-control border border-danger ${styles.tacdisable} ${styles.marginErr}`
                : `form-control  ${styles.tacdisable}`
            }
            onKeyPress={onKeyPress}
            onBlur={onBlur}
            required={required}
            placeholder=" "
            disabled={disable}
            maxLength={6}
            ref={ref}
            autoFocus={autofocus}
          />
          <label htmlFor={id} className={`text-muted ${classNameLabel}`}>
            {label}
            {required && <span className="text-danger"> *</span>}
          </label>
          {error && (
            <span className={`text-danger ${classNameError}`}>{error}</span>
          )}
        </div>
      ) : (
        <div
          className={`form-group ${className}`}
          // style={{ margin: "10px", color: "#999999", width: "30%" }}
        >
          <input
            id={id}
            type={type || 'text'}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
            maxLength={maxLength}
            name={name}
            max={max}
            onBlur={onBlur}
            autoFocus={autofocus}
            className={
              error
                ? `form-control border border-danger ${styles.opacityField} ${styles.marginErr}`
                : `form-control  ${styles.opacityField}`
            }
            disabled={disable}
            required={required}
            placeholder=" "
            ref={ref}
          />
          <label htmlFor={id} className={`text-muted ${classNameLabel}`}>
            {label}
            {required && <span className="text-danger"> *</span>}
          </label>
          {error && (
            <span className={`text-danger ${classNameError}`}>{error}</span>
          )}
        </div>
      )}
    </>
  );
};

TextField.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  required: PropTypes.any,
  error: PropTypes.string,
};

export default TextField;
